import { render, staticRenderFns } from "./ShippingPrivacyHintCheck.vue?vue&type=template&id=02587d6e&"
import script from "./ShippingPrivacyHintCheck.vue?vue&type=script&lang=js&"
export * from "./ShippingPrivacyHintCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02587d6e')) {
      api.createRecord('02587d6e', component.options)
    } else {
      api.reload('02587d6e', component.options)
    }
    module.hot.accept("./ShippingPrivacyHintCheck.vue?vue&type=template&id=02587d6e&", function () {
      api.rerender('02587d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/checkout/ShippingPrivacyHintCheck.vue"
export default component.exports